export const clearStoredAuthTokens = () => {
    Object.keys(localStorage).forEach((key) => {
        if (/token|auth/i.test(key)) {
            localStorage.removeItem(key);
        }
    });
};
